<div class="content">
  <div *ngIf="IsActiveStep('ImportantInformation')">
    <app-ii-step [stepAccount]="account" (stepModelChanged)="onStepModelChanged($event)"></app-ii-step>
  </div>
  <div *ngIf="IsActiveStep('YourProfile')">
    <app-yp-step
      [stepAccount]="account"
      [user]="user"
      (stepModelChanged)="onStepModelChanged($event)"
    ></app-yp-step>
  </div>
  <div *ngIf="IsActiveStep('AccountSecurity')">
    <app-as-step [stepAccount]="account" (stepModelChanged)="onStepModelChanged($event)"></app-as-step>
  </div>
</div>
